import { createSelector } from '@reduxjs/toolkit';
export const hasQueryCorrectionSelector = createSelector((state) => state.queryCorrection.correctedQuery !== '' || state.wasCorrectedTo !== '', (hasQueryCorrection) => hasQueryCorrection);
